import { urls } from 'Utilities/dataHelpers';
import log from 'Utilities/log';
import mediator from 'Utilities/mediator';
export const verifyCid = (cid, envCountry, redirect_uri, accountId, accessToken) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.libreSharingApiCountryUrl + 'v1/insulet/cid/' + accountId,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        cid,
        country: envCountry,
        redirectUrl: redirect_uri
      }
    }).then(result => {
      if (result.data?.redirectURL) {
        resolve(result.data.redirectURL);
        return;
      }
      reject();
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const createConnection = (cid, redirect_uri, accountId, accessToken) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.libreSharingApiCountryUrl + 'v1/insulet/createconnection/' + accountId,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        cid,
        redirectUrl: redirect_uri
      }
    }).then(result => {
      if (result.data?.redirectURL) {
        resolve(result.data.redirectURL);
        return;
      }
      reject();
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};